import { Component, EventEmitter, HostListener, Injector, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { ControlValueAccessor, NgControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { FileBase64Model } from '../../../core/models/api/file-base64-model';
import { regexBase64Header, toBase64 } from '../../../core/operators/base64.converter';

export const fileTypeImage = '.jpg, .png, .jpeg, .gif, .svg, .tiff';

@Component({
    selector: 'shared-file-upload',
    templateUrl: 'file-upload.component.html',
    providers: [{ provide: NG_VALUE_ACCESSOR, multi: true, useExisting: FileUploadComponent }],
    styleUrls: ['./file-upload.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FileUploadComponent implements ControlValueAccessor, OnInit {
    private control: NgControl | undefined;
    @Output() Documentdeleted = new EventEmitter<boolean>();

    public onChange = (_value: FileBase64Model | null) => { };
    public onTouched = () => { };

    public touched = false;
    public disabled = false;
    public fileuploadSuccessful = false;

    public file: FileBase64Model | null | undefined;

    @Input()
    public accept: string[] | string = fileTypeImage;
    @Input()
    public uploadSucess:boolean = false ;

    public active = false;

    @HostListener('dragover', ['$event'])
    public onDragOver(event: DragEvent) {
        event.stopPropagation();
        event.preventDefault();
        this.active = true;
    }

    @HostListener('drop', ['$event'])
    public onDrop(event: DragEvent): void {
        event.preventDefault();
        event.stopPropagation();
        if (event.dataTransfer) {
            this.onFileChange(event.dataTransfer.files[0]);
        }
    }

    @HostListener('dragleave')
    public onDragLeave() {
        this.active = false;
    }

    constructor(
        private readonly sanitizer: DomSanitizer,
        private readonly injector: Injector) {

    }

    public ngOnInit(): void {
        if (this.control === undefined) {
            this.control = this.injector.get(NgControl);
            this.control.valueAccessor = this;
        }
    }

    public onFileSelected(event: any): void {
        this.onFileChange(event.target.files[0]);
    }

    public onClear(): void {
        this.file = null;
        this.onChange(this.file);
        this.fileuploadSuccessful=false;
        this.uploadSucess = false;
        this.Documentdeleted.emit(true);
    }
    
    public writeValue(value: FileBase64Model | null): void {
        this.file = value;
    }

    public registerOnChange(onChange: any): void {
        this.onChange = onChange;
    }

    public registerOnTouched(onTouched: any): void {
        this.onTouched = onTouched;
    }

    public markAsTouched(): void {
        if (!this.touched) {
            this.onTouched();
            this.touched = true;
        }
    }

    public get isImageType(): boolean {
        return !!this.file && new RegExp(fileTypeImage).test(this.file.contentType);
    }

    public get imageSrc(): SafeResourceUrl | null {
        if (this.file) {
            const contentBase64 = this.file.contentBase64.replace(regexBase64Header, '');
            const objectUrl = `data:${this.file.contentType};base64,${contentBase64}`;
            return this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);
        }

        return null;
    }

    public get hasContentTypeError(): boolean {
        if (!this.control) {
            return false;
        }

        const { dirty, touched } = this.control;
        return this.control.hasError('contentType') ? !!(dirty || touched) : false;
    }

    public get hasMaxContentSizeError(): boolean {
        if (!this.control) {
            return false;
        }

        const { dirty, touched } = this.control;
        return this.control.hasError('maxContentSize') ? !!(dirty || touched) : false;
    }

    private onFileChange(file: File | null | undefined): void {
        if (file) {
          toBase64(file)
            .then((result) => {
              this.file = result;
              this.onChange(result);
            })
            .finally(() => this.markAsTouched());
        }
      }
      ngOnChanges(){
        this.fileuploadSuccessful=this.uploadSucess
      }
    }
